import { useFormController } from '@dreryk/react-common';
import { Form } from '@dreryk/react-components';

import {
   VisitDocumentsDiagnosesFormBean,
   VisitDocumentsDiagnosesFormController,
} from './VisitDocumentsDiagnosesForm.types';
import { VisitDocumentsDiagnosesInteractiveTable } from './VisitDocumentsDiagnosesInteractiveTable';
import { INITIAL_FORM_VALUES } from './VisitDocumentsDiagnosesForm.constants';

type VisitDocumentsDiagnosesFormProps = Readonly<{
   children: (renderProps: Pick<VisitDocumentsDiagnosesFormController, 'handleSubmit'>) => JSX.Element;
}>;

export const VisitDocumentsDiagnosesForm = (props: VisitDocumentsDiagnosesFormProps): JSX.Element => {
   const { handleSubmit, register } = useFormController<VisitDocumentsDiagnosesFormBean>(INITIAL_FORM_VALUES);

   return (
      <Form>
         <VisitDocumentsDiagnosesInteractiveTable register={register} />
         {props.children({ handleSubmit: handleSubmit })}
      </Form>
   );
};
